// extracted by mini-css-extract-plugin
export var container = "_cm-0";
export var icon = "_cm-1";
export var text = "_cm-2";